import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import find from 'lodash/find';
import { DEFAULT_ASPECT_RATIOS, IAspectRatioInfo } from '../../../constants/common.constants';

export interface UIChooseMotiveModalConfig {
  imgUrl: string;
  aspectRatios: IAspectRatioInfo[];
  selectedAspectRatioId: string;
  enableResize: boolean;
  keepBgTransparent?: boolean;
  fitIntoAspectRatio?: boolean;
  maxImageSize?: number;
}

@Component({
  standalone: false,
  templateUrl: './ui-choose-motive-modal.component.html',
  styleUrls: ['./ui-choose-motive-modal.component.scss']
})
export class UiChooseMotiveModalComponent implements OnInit, UIChooseMotiveModalConfig{

  @Input() imgUrl: string;
  @Input() maxImageSize?: number;
  @Input() aspectRatios: IAspectRatioInfo[];
  @Input() selectedAspectRatioId: string;
  @Input() enableResize: boolean;
  @Input() keepBgTransparent: boolean;
  @Input() fitIntoAspectRatio = false;
  @Input() imagesForChooseSrc: string[];

  resultImgUrl: string;
  file: File;

  public selectedAspectRatio: IAspectRatioInfo = null;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.aspectRatios = this.aspectRatios ? this.aspectRatios : DEFAULT_ASPECT_RATIOS;
    this.selectedAspectRatio = find(this.aspectRatios, { id: this.selectedAspectRatioId }) || null;
  }

  uploadImage() {
    this.modal.close(this.selectedAspectRatio
      ? this.resultImgUrl
      : this.imgUrl);
  }

  onResultUrlChanged(url: string) {
    this.resultImgUrl = url;
  }
}
